module.exports = __webpack_public_path__ + "img/qr-cfkj.4ed89f74.png";